import '../App.css';

import community from '../assets/images/community.png';
import globe from '../assets/images/globe.png';
import gift from '../assets/images/gift.png';
import aboutImage from '../assets/images/about.png';

function About() {
    return (
        <section className="about-section" id="about">

            <div className="container">

                <div className="about-box">

                    <div className="row g-0 align-items-center">

                        <div className="col-lg-8">

                            <div className="about-left">

                                <h2>ABOUT SKYGOOSE</h2>

                                <span className="title-line"></span>

                                <div className="about-features">

                                    <div className="about-item">

                                        <img
                                            src={community}
                                            alt=""
                                        />

                                        <h4>Community<br />First</h4>

                                        <p>
                                            Stronger<br />
                                            together.
                                        </p>

                                    </div>

                                    <div className="about-item">

                                        <img
                                            src={globe}
                                            alt=""
                                        />

                                        <h4>Real Travel<br />Utility</h4>

                                        <p>
                                            Real use case in<br />
                                            the travel industry.
                                        </p>

                                    </div>

                                    <div className="about-item">

                                        <img
                                            src={gift}
                                            alt=""
                                        />

                                        <h4>Shared<br />Benefits</h4>

                                        <p>
                                            Holders grow,<br />
                                            together.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="col-lg-4">

                            <img
                                src={aboutImage}
                                className="about-image"
                                alt=""
                            />

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default About;